import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1024px',
    padding: '0 16px',
    // minHeight: 'calc(100dvh - 160px)',

    // [theme.breakpoints.up('laptop')]: {
    //   minHeight: 'calc(100dvh - 200px)',
    // },
  },
  cameraWrapper: {
    width: '400px',
    height: '400px',
    borderRadius: '10px',
    overflow: 'hidden',

    [theme.breakpoints.down('tablet')]: {
      marginLeft: 'auto',
      marginRight: 'auto',

      width: '100%',
      height: 'auto',
      maxWidth: '400px',
      maxHeight: '400px',
    },
  },
  selectionItem: {
    '&&': {
      display: 'flex',
      alignItems: 'center',

      width: '100%',

      wordWrap: 'break-word',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xs,
      },

      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xxl,
      },
    },
  },
  selectionText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.33,

      wordWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'normal',
    },
  },

  selectionTextDark: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
    },
  },

  selectionSubtext: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      wordWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'normal',
    },
  },

  image: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        width: 50,
        height: 50,

        filter: `drop-shadow(0px 2px 10px ${theme.palette.custom.grey})`,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 80,
        height: 80,
      },

      borderRadius: '50%',
    },
  },

  selectionWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: theme.palette.custom.white,
      justifyContent: 'space-between',

      width: '100%',
      marginBottom: '15px',

      wordWrap: 'break-word',
      border: `1px solid ${theme.palette.custom.grey}`,

      textDecoration: 'none',

      [theme.breakpoints.down('tablet')]: {
        // margin: `${SPACES.xxxs} 0`,

        padding: SPACES.xs,

        borderRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        // margin: `${SPACES.xs} 0`,

        padding: `${SPACES.xxl} ${SPACES.xxl} ${SPACES.xl}`,

        borderRadius: 15,
      },

      // cursor: props.disableClickable ? 'auto' : 'pointer',
      transition: 'background-color 0.3s ease-in-out',
    },
  },
  verifyModal: {
    '&&': {
      padding: SPACES.xxl,
      paddingTop: SPACES.xxxxxl,
      minWidth: '334px',

      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
  },

  formVerifySubmitDetailswrapper: {
    '&&': {
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: `${SPACES.xxl} 0 ${SPACES.xxxl}`,

      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: SPACES.s,

      borderRadius: '15px',
      border: `1px solid ${theme.palette.custom.grey}`,

      width: '100%',
      maxWidth: '400px',
      minHeight: 146,
    },
  },

  formVerifySubmitDetailsIcon: {
    width: 22,
    height: 22,
    fill: theme.palette.custom.black,
  },

  formVerifySubmitDetailsTitle: {
    '&&': {
      textAlign: 'center',
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.388,
      color: theme.palette.custom.darkBlue2,
      padding: '0 5px',
    },
  },
  formVerifySubmitDetailsText: {
    '&&': {
      textAlign: 'center',
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      color: theme.palette.custom.darkBlue2,
      padding: '0 5px',
    },
  },

  deleteIcon: {
    '&&': {
      width: '28px',
      height: '28px',
    },
  },
  // supText: {
  //   fontStyle: 'italic',
  //   fontSize: '10px',
  //   color: theme.palette.custom.primary,
  //   marginLeft: '3px',
  // },
}))
